import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import {BrowserRouter as Router, Routes,Route} from 'react-router-dom'
import { Link,useNavigate,useLocation } from 'react-router-dom';
import axios from 'axios'; 
import useAuth from '../hooks/useAuth';
import {useForm} from 'react-hook-form';
import {DevTool} from '@hookform/devtools'
// Config
import { 

  WAREHOUSES_BASE_URL

 } from '../config';
// Components
import Knoppie from './Knoppie'
import Header from './Header'
import Home from './Home';
import Thumb from './Thumb';

// Hook

// Image

let renderCount = 0

const NewWarehouse = () => {
  
  const auth = useAuth();
  const{clubid}=useParams()
  console.log(clubid)
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "./";
  
  const form = useForm()
  const {register, control, handleSubmit, formState} = form
  const {errors} = formState
  
  const [errMessage,setErrMessage] = useState("");
  const [success, setSuccess]= useState(false);
  const username = auth.auth.user.username
  const access = auth.auth.user.userRole
  const accessToken = auth.auth.accessToken
  
  console.log(" from = " +from)

  const onSubmit = async data => {
     
      console.log("Form Submitted",data)

      try {
        const response =  await axios.post(`${WAREHOUSES_BASE_URL}`,
          JSON.stringify({data:data}),
          {
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Bearer '+accessToken

            }
          }
        );
       
        navigate(from, {replace: true});

      } catch (error) {

        if(!error.response){
          setErrMessage("No server response")
        }else if (error.response?.status === 400){
          setErrMessage("Missing data")
        }else if (error.response?.status === 500){
          
          setErrMessage(error.response?.data.msg.message)
        } else {
          setErrMessage('failed')
        }
        console.log(error)
      }
      
      
    }
    renderCount++
  return (
    <>
    <h1>RenderCount {renderCount/2}</h1>
    <Header username={username} role={access} Login={false}></Header>
    <Knoppie
      destination={from}
      text={'Back'}
      clickable
      />
      
 <section>

<p >
{errMessage}
</p>
</section>
      <form  onSubmit={handleSubmit(onSubmit)} noValidate className="FormClass">
        
      <h1>Add new Warehouse:</h1>
      <div className='Lineitem'>
      <label>Name</label>
      <input className="inputsize" type={"text"} {...register('name',{
        required:'name is required'
      })}/>
      <p className='error'>{errors.itemcode?.message}</p>
      </div>
      {/* <div className='Lineitem'>
      <label>Description</label>
          <input className="inputsize" type={"text"}  {...register('desc',{
            required:'name is required'
          })}/>
<p className='error'>{errors.desc?.message}</p>
      </div>
      <div className='Lineitem'>
          <label>Group</label> 
          <input className="inputsize" type={"text"} {...register('group',{
            required:'group is required'
          })}/>
<p className='error'>{errors.group?.message}</p>
      </div>
      <div className='Lineitem'>
          <label>Group Name</label> 
          <input className="inputsize" type={"text"} {...register('longstockGroup')}/>
        
      </div>
      <div className='Lineitem'>
          <label>location</label> 
          <input className="inputsize" type={"text"} {...register('location',{
             required:'location is required'
          })}/>
          
      </div>
      <div className='Lineitem'>
          <label>Sales Group</label> 
          <input className="inputsize" type={"text"} {...register('salesgrp')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Sales Group Name</label> 
          <input className="inputsize" type={"text"} {...register('longsalesGroup')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Image Path</label> 
          <input className="inputsize" type={"text"} {...register('image_path')}/>
        
      </div>
      <div className='Lineitem'>
          <label>Default Unit</label> 
          <input className="inputsize" type={"text"} {...register('defunit',{
            required:"default Unit required"
          })}/>
        
      </div>
      <div className='Lineitem'>
          <label>Average cost</label> 
          <input className="inputsize" type={"number"} {...register('avecost',{
            required:"average cost required"
          })}/>
        
      </div>
      <div className='Lineitem'>
          <label>Stock on Hand</label> 
          <input className="inputsize" type={"number"} {...register('stockonhand',{
            required:"stock on hand required"
          })}/>
        
      </div>
       */}
             
          
          
          <button>Submit</button>
      </form>

      <DevTool control={control}/>
      
      </>
  )
};

export default NewWarehouse;
